// @flow

import * as React from 'react';
import Grid from 'styled-components-grid';

import { withTranslation } from '@i18n';
import ContactPageNew from '@components/ContactPageNew/index';

import type { PropsDetails } from './types';

import {
  StyledContentTop,
  StyledCover,
  StyledFormUnit,
  StyledEmailFormUnit,
  StyledInterviewWrapper
} from './styles/details';

const DetailsComponent = ({
  t,
  isActive,
  time,
  location,
  isMobile,
  clickEvent,
  setSuccess,
  treatmentPageValue,
  onTimeSelect,
  slide,
  formName,
  isModal,
  modalState,
  doctor,
  hospital,
  setModalSlide,
  signUp,
  contactUs
}: PropsDetails) => {
  if (!isActive) {
    return null;
  }

  return (
    <StyledCover formName={formName} isModal={isModal}>
      <StyledContentTop formName={formName} isModal={isModal}>
        <Grid>
          <StyledInterviewWrapper size={{ mobile: 1, desktop: 1 }}>
            <ContactPageNew
              formName="MiniFlowForm"
              contract="preference_contract_temporary"
              treatment={treatmentPageValue}
              doctor={doctor}
              hospital={hospital}
              isMobile={isMobile}
              hours={time}
              setSuccess={setSuccess}
              time={time}
              location={location}
              clickEvent={clickEvent}
              StyledCustomUnit={StyledFormUnit}
              StyledCustomEmailUnit={StyledEmailFormUnit}
              newt={t}
              onTimeSelect={onTimeSelect}
              slide={slide}
              treatmentFormName={formName}
              signUp={signUp}
              modalState={modalState}
              setModalSlide={setModalSlide}
              isModal={isModal}
              contactUs={contactUs}
            />
          </StyledInterviewWrapper>
        </Grid>
      </StyledContentTop>
    </StyledCover>
  );
};

const Details = withTranslation('HowItWorksScreen')(DetailsComponent);

Details.getInitialProps = (): {} => ({
  namespacesRequired: ['HowItWorksScreen']
});

export default Details;
